import axios from 'axios';
import logComponent from '../logComponent';
import getConfig from './getConfig';

const Weather = (function() {
  function GetCurrent(monitoredIndividualId) {
    if (logComponent('Weather')) { console.debug('Weather GetCurrent'); }
    let params = monitoredIndividualId ? { monitoredIndividualId } : {};
    
    return axios.get('api/Weather/GetCurrent', getConfig( params));
  }

  return {
    GetCurrent
  }
})();

export default Weather;